export default "https://assets-v2.scaler.com/packs/files/mobile-confetti.53345d.lottie";